import { render, staticRenderFns } from "./FeaturedUserDialog.vue?vue&type=template&id=52c07f77&"
import script from "./FeaturedUserDialog.vue?vue&type=script&lang=js&"
export * from "./FeaturedUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports